import { render, staticRenderFns } from "./PriceDeleteDialog.vue?vue&type=template&id=27d39cde&scoped=true"
import script from "./PriceDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./PriceDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./PriceDeleteDialog.vue?vue&type=style&index=0&id=27d39cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d39cde",
  null
  
)

export default component.exports